import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HealthService {
  baseAPI: string = environment.baseURL;

	constructor(private httpClient: HttpClient) { }

	public getAccessTicket(data: any):Observable<any>{
		return this.httpClient.post(`${this.baseAPI}/getAccessTicket`,data);
	}

	public getAllContainers(data: any):Observable<any>{
		return this.httpClient.post(`${this.baseAPI}/getAllContainers`,data);
	}

	public getStatusMongo():Observable<any>{
		return this.httpClient.post(`${this.baseAPI}/getStatusMongo`,{});
	}

	public getStatusPIM():Observable<any>{
		return this.httpClient.post(`${this.baseAPI}/getStatusPIM`,{});
	}

	public getStatusCore():Observable<any>{
		return this.httpClient.post(`${this.baseAPI}/getStatusCore`,{});
	}
}
